<template><!-- <?xml version="1.0" encoding="iso-8859-1"?> -->
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 508.388 508.388" style="enable-background:new 0 0 508.388 508.388;" xml:space="preserve">
<g>
	<g>
		<path d="M488.204,18.56c-24.748-24.748-64.901-24.748-89.659,0.01l-17.143,17.121c-12.195,12.262-12.195,32.031-0.009,44.217
			l6.037,6.037c-0.829,0.616-1.635,1.276-2.387,2.028l-63.245,63.245c-40.049-28.695-94.632-28.025-134.028,2.614l-14.616,12.082
			L73.88,66.64c-8.331-8.331-21.839-8.331-30.17,0s-8.331,21.839,0,30.17l104.625,104.625c0.283,1.297,0.676,2.583,1.212,3.838
			c4.373,10.234,0.064,26.527-12.491,39.083c-14.804,14.79-33.989,17.696-43.005,9.964c-7.88-6.759-19.482-6.863-27.483-0.247
			l-13.184,10.901c-1.253,1.036-2.384,2.213-3.37,3.506l-25.408,33.323c-32.331,42.37-30.763,102.433,5.74,139.782
			c0.54,0.531,33.964,33.966,33.964,33.966c47.714,47.687,126.405,42.784,167.817-10.456l20.445-25.537
			c6.331-7.909,6.227-19.18-0.25-26.97c-7.566-9.1-4.576-28.159,10.115-42.85c12.043-12.029,27.607-16.519,37.984-12.85
			c1.447,0.512,2.922,0.845,4.401,1.035l101.555,101.555c8.331,8.331,21.839,8.331,30.17,0c8.331-8.331,8.331-21.839,0-30.17
			l-97.62-97.62L350.6,317.1c30.911-39.725,31.583-94.59,2.454-134.795l-0.916-1.087l63.075-63.075
			c0.752-0.752,1.412-1.558,2.028-2.387l9.634,9.634c12.214,12.214,31.993,12.214,44.207,0l17.131-17.131
			C512.994,83.479,512.994,43.318,488.204,18.56z M317.106,290.67l-18.087,22.599c-23.092-2.11-48.012,7.578-66.744,26.287
			c-24.05,24.05-32.865,57.945-22.092,84.677l-11.55,14.429c-25.842,33.22-74.596,36.258-104.158,6.712l-33.063-33.063
			c-0.347-0.378-0.347-0.378-1.395-1.366c-20.394-20.912-21.342-57.25-1.488-83.269l23.776-31.182
			c26.791,10.91,60.789,2.138,84.913-21.963c19.607-19.607,29.301-45.97,26.011-69.86l21.233-17.561
			c22.021-17.115,52.449-18.802,76.498-5.056l-55.251,55.251c-8.331,8.331-8.331,21.839,0,30.17s21.839,8.331,30.17,0l55.62-55.62
			C336.417,236.235,335.002,267.67,317.106,290.67z M458.043,78.09l-9.064,9.064l-29.345-29.345l9.071-9.06
			c8.105-8.105,21.243-8.105,29.338-0.009C466.159,56.844,466.159,69.974,458.043,78.09z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>